let toastInstance = null;
export const toastService = {
  setToastInstance(toast) {
    toastInstance = toast;
  },
  add(options){
    if (!toastInstance) {
      console.error('Toast instance not initialized');
      return;
    }
    toastInstance.add(options);
  },
  success (message, title = 'Успех'){
    this.add({ severity: 'success', summary: title, detail: message, life: 3000 })
  },
  error(message, title = 'Ошибка'){

    this.add({ severity: 'error', summary: title, detail: message, life: 8000 })
  },
  warn(message, title = 'Внимание'){
    this.add({ severity: 'warn', summary: title, detail: message, life: 4000 })
  },
  info(message, title = 'Информация'){
    this.add({ severity: 'info', summary: title, detail: message, life: 3000 })
  }
}

export default {
  install(app) {
    app.mixin({
      created() {
        this.$toast = toastService; //для Options API
      }
    });
    app.provide('toast', toastService); //для Composition API inject
    console.log('✅ Toast плагин загружен')
  }
};